export default "__VITE_ASSET__CdO9i9tL__"